export const PROJECT_CONFIG_PATH = "project/config";

export enum SystemFiles {
    LOGO_LIGHT_BG = "logo-light-bg.png",
    LOGO_DARK_BG = "logo-dark-bg.png",
    FONT_LIGHT = "light-font.woff2",
    FONT_REGULAR = "regular-font.woff2",
    FONT_BOLD = "bold-font.woff2",
}
